import { useMemo } from "react";

export function useCommitStatusColors(
  behindBy?: number,
  isByoc = false,
  currentCommitDate?: string | null,
) {
  return useMemo(() => {
    if (behindBy === undefined) {
      return {
        bg: "bg-gray-50",
        border: "border-gray-200",
        icon: "text-gray-600",
        ring: "ring-gray-200/50",
        text: "text-gray-700",
      };
    }

    // Calculate days behind if we have the date
    let daysBehind = 0;
    if (currentCommitDate) {
      const commitDate = new Date(currentCommitDate);
      const now = new Date();
      daysBehind = Math.floor(
        (now.getTime() - commitDate.getTime()) / (1000 * 60 * 60 * 24),
      );
    }

    // Determine color based on both commits behind and days behind
    // Use a weighted approach: consider both metrics
    const isGreen = () => {
      const commitThreshold = isByoc ? 32 : 16;
      const daysThreshold = isByoc ? 6 : 3; // 6 days for BYOC, 3 days for SaaS
      return behindBy <= commitThreshold && daysBehind <= daysThreshold;
    };

    const isOrange = () => {
      const commitThreshold = isByoc ? 128 : 64;
      const daysThreshold = isByoc ? 14 : 7; // 2 weeks for BYOC, 1 week for SaaS
      return behindBy <= commitThreshold && daysBehind <= daysThreshold;
    };

    if (isGreen()) {
      return {
        bg: "bg-green-50",
        border: "border-green-200",
        icon: "text-green-600",
        ring: "ring-green-200/50",
        text: "text-green-700",
      };
    }
    if (isOrange()) {
      return {
        bg: "bg-orange-50",
        border: "border-orange-200",
        icon: "text-orange-600",
        ring: "ring-orange-200/50",
        text: "text-orange-700",
      };
    }
    return {
      bg: "bg-red-50",
      border: "border-red-200",
      icon: "text-red-600",
      ring: "ring-red-200/50",
      text: "text-red-700",
    };
  }, [behindBy, isByoc, currentCommitDate]);
}
